import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    Divider,
    Box,
    Tab,
    Grid,
    Tabs,
    IconButton
} from "@mui/material";
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { motion } from 'framer-motion';
import AddItemImage from "./AddItemImage";
import ItemImageList from "./ItemImageList";
import { AddPhotoAlternate, Close, ReplyAll, VideoCall } from "@mui/icons-material";
import AddItemVideo from "./AddItemVideo";
import ItemVideoList from "./ItemVideoList";

//FUNCTION
const ItemAdvance = () => {
    //#region code
    const location = useLocation();
    const navigate = useNavigate();
    const [formData, setFormData] = useState(location.state);
    const [openAddImage, setOpenAddImage] = useState(false);
    const [openVideo, setOpenVideo] = useState(false);
    const [isEdited, setIsEdited] = useState(false);
    const [isImageChanged, setIsImageChanged] = useState(false);
    const [isVideoChanged, setIsVideoChanged] = useState(false);
    const [tabOpen, setTabOpen] = useState('image');

    const handleTabSwitch = (e, value) => {
        setTabOpen(value);
    }

    const handleOpenImage = () => {
        setOpenAddImage(true);
    };

    const handleCloseImage = () => {
        setIsImageChanged(!isImageChanged);
        setOpenAddImage(false);
    };

    const handleVideoOpen = () => {
        setOpenVideo(true);
    }

    const handleVideoClose = () => {
        setIsVideoChanged(!isVideoChanged);
        setOpenVideo(false);
    }

    //#endregion

    return (
        <>
            <Divider
                sx={{
                    backgroundColor: '#33333366',
                    my: '2px',
                    width: '100%'
                }}
            />
            <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
                <IconButton onClick={() => { navigate('/master-entry/item') }} color="primary" title="Go back" sx={{fontSize:'36px'}}>
                    <ReplyAll fontSize="36px"/>
                </IconButton>
                <Tabs value={tabOpen} onChange={handleTabSwitch} centered>
                    <Tab label="Image" value={"image"} sx={{fontWeight:700}} />
                    <Tab label="Video" value={"video"} sx={{fontWeight:700}} />
                </Tabs>
                <IconButton onClick={() => { navigate('/master-entry/item') }} color="error" title="Close" sx={{fontSize:'36px'}}>
                    <Close fontSize="36px"/>
                </IconButton>
            </Box>

            <Divider
                sx={{
                    backgroundColor: '#33333366',
                    mt: '2px',
                    width: '100%'
                }}
            />

            <TabContext value={tabOpen}>
                <TabPanel value={'image'} sx={{ width: '100%', p: 0 }}>
                    <ItemImageList itemData={formData} />
                </TabPanel>
                <TabPanel value={'video'} sx={{ width: '100%', p: 0 }}>
                    <ItemVideoList itemData={formData} />
                </TabPanel>
            </TabContext>
        </>
    )
}

export default ItemAdvance;